import { Encumbrance } from 'types';

import {
  PartnerBookShare,
  PartnerRegisterEncumbrance,
  PartnerRegisterShare,
} from '../types/PartnerBook';

const getShareId = (share: string | undefined): string | undefined => {
  if (!share) return undefined;
  return typeof share === 'string' ? share : String(share);
};

const getShareClassName = (shareClass: PartnerBookShare['shareClass']): string => {
  if (!shareClass || typeof shareClass === 'string') {
    return '';
  }

  return shareClass.name || '';
};

const mapEncumbranceForRegister = (
  encumbrance: Encumbrance
): PartnerRegisterEncumbrance => ({
  from: encumbrance.from,
  to: encumbrance.to,
  type: encumbrance.type,
  coOwners: encumbrance.coOwners?.map((coOwner) => ({
    name: coOwner.name,
    percentage: coOwner.percentage,
  })),
});

const buildEncumbrancesByShare = (
  encumbrances: Encumbrance[]
): Record<string, Encumbrance[]> =>
  encumbrances.reduce((acc: Record<string, Encumbrance[]>, encumbrance) => {
    const shareId = getShareId(encumbrance.share);

    if (!shareId) return acc;

    if (!acc[shareId]) {
      acc[shareId] = [];
    }

    acc[shareId].push(encumbrance);
    return acc;
  }, {});

const mapShareForRegister = (
  share: PartnerBookShare,
  encumbrancesByShare: Record<string, Encumbrance[]>
): PartnerRegisterShare => ({
  _id: share._id,
  from: share.from,
  to: share.to,
  shareClass: { name: getShareClassName(share.shareClass) },
  encumbrances: (encumbrancesByShare[share._id] || []).map(
    mapEncumbranceForRegister
  ),
});

export const attachEncumbrancesToShares = (
  shares: PartnerBookShare[] | undefined,
  encumbrances: Encumbrance[] = []
): PartnerRegisterShare[] | undefined => {
  if (!shares?.length) {
    return shares ? [] : undefined;
  }

  const encumbrancesByShare = buildEncumbrancesByShare(encumbrances);

  return shares.map((share) => mapShareForRegister(share, encumbrancesByShare));
};
